var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji_events_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.4232 105.062V97.3744H57.6563V79.8113C53.3066 78.9374 49.4628 77.1075 46.125 74.3216C42.7872 71.5357 40.4152 68.0631 39.0091 63.904C33.0957 63.201 28.1054 60.6911 24.0383 56.3743C19.9711 52.0575 17.9375 46.9325 17.9375 40.9994V35.8744C17.9375 33.7784 18.6948 31.9732 20.2093 30.4588C21.7237 28.9443 23.5289 28.187 25.6249 28.187H37.5505V17.937H85.4493V28.187H97.3749C99.4708 28.187 101.276 28.9443 102.79 30.4588C104.305 31.9732 105.062 33.7784 105.062 35.8744V40.9994C105.062 46.9325 103.029 52.0575 98.9614 56.3743C94.8943 60.6911 89.9041 63.201 83.9907 63.904C82.5846 68.0631 80.2126 71.5357 76.8748 74.3216C73.5369 77.1075 69.6932 78.9374 65.3435 79.8113V97.3744H83.5766V105.062H39.4232ZM37.5505 55.6451V35.8744H25.6249V40.9994C25.6249 44.5737 26.7452 47.7128 28.9857 50.4166C31.2263 53.1204 34.0812 54.8632 37.5505 55.6451ZM61.4999 72.4393C66.0007 72.4393 69.8198 70.8706 72.9572 67.7332C76.0946 64.5957 77.6634 60.7766 77.6634 56.2759V25.6244H45.3364V56.2759C45.3364 60.7766 46.9051 64.5957 50.0426 67.7332C53.1799 70.8706 56.999 72.4393 61.4999 72.4393ZM85.4493 55.6451C88.9185 54.8632 91.7735 53.1204 94.014 50.4166C96.2546 47.7128 97.3749 44.5737 97.3749 40.9994V35.8744H85.4493V55.6451Z",
    fill: "#9BCB49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.ec71aff2dc238d5b60a983f744616afb.svg";
export { ForwardRef as ReactComponent };